"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalFormat = exports.DatePicker = void 0;
const generatePicker_1 = __importDefault(require("antd/es/date-picker/generatePicker"));
const dayjs_1 = __importDefault(require("dayjs"));
const localeData_1 = __importDefault(require("dayjs/plugin/localeData"));
const weekday_1 = __importDefault(require("dayjs/plugin/weekday"));
const dayjs_2 = __importDefault(require("rc-picker/es/generate/dayjs"));
const zh_CN_1 = __importDefault(require("antd/es/date-picker/locale/zh_CN"));
require("dayjs/locale/zh-cn");
dayjs_1.default.extend(weekday_1.default);
dayjs_1.default.extend(localeData_1.default);
exports.DatePicker = (0, generatePicker_1.default)(dayjs_2.default);
class LocalHelper {
    getDefinedChineseLocal() {
        const definedChineseLocal = Object.assign(Object.assign({}, zh_CN_1.default), { lang: Object.assign(Object.assign({}, zh_CN_1.default.lang), { monthFormat: 'M月', shortWeekDays: ['日', '一', '二', '三', '四', '五', '六'] }) });
        return definedChineseLocal;
    }
}
exports.LocalFormat = new LocalHelper();
